export interface IrisUserSettingsI<T> {
  createdBy?: number;
  createdOn?: Date;
  id?: number;
  module?: string;
  settings: T;
  updatedBy?: number;
  updatedOn?: Date;
  userId?: number;
}

export interface IrisUserColumnsSettings {
  columns: IrisUserColumnSettingsI[];
}

export interface IrisUserColumnSettingsI {
  field: string;
  index: number;
  hide: boolean;
  pinned?: boolean;
}

export interface IrisTableSettingsOptionsI {
  pinable?: boolean;
  disabledPinning?: string[];
  maxAllowedColumnsToPin?: number;

  sortable?: boolean;
  disabledSorting?: string[];

  hideable?: boolean;
  disabledHiding?: string[];

  denyResetToDefault?: boolean;
  title?: string;
  description?: string;
}

export enum IrisGridPinnedType {
  Left = 'left',
  Right = 'right',
}
